export default "__VITE_ASSET__Bgiqeohw__"